import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';




import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const GitaDharaClass6 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara6/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara6/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara6/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara6/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/school-programs/GitaDhara6/5.webp`;

   
    const photos = [
      
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
          {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        }

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Gita Dhara
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                               Classes: 6    Date: 17 December 2025  <br />
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ When young minds learn the wisdom of the Bhagavad Gita, they grow not only in knowledge, but in discipline, values and compassionate living. ”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                A Bhagavad Gita learning session was conducted on Wednesday, 17 December 2025 for Class 6 students with the objective of nurturing values, inner discipline and holistic development at a young age. The session was thoughtfully designed to introduce students to the timeless wisdom of the Bhagavad Gita in a simple, engaging and age-appropriate manner.  
                                <br></br>
                                The session began with collective chanting of selected Bhagavad Gita shlokas. This practice helped students improve concentration, pronunciation, and rhythmic awareness, while also creating a calm and focused learning environment. An interactive storytelling segment followed, where short moral stories drawn from the teachings of the Gita were narrated. These stories helped students easily relate the philosophical messages to real-life situations. The session emphasised essential values related to the mind and spirit, including self-control, renunciation, sacrifice, sincerity and forgiveness.
                                <br></br>
                                Throughout the session, students actively participated with enthusiasm and discipline. They listened attentively, responded thoughtfully during interactions and demonstrated respect and curiosity. Overall, the Bhagavad Gita session served as a valuable learning experience that contributed to the moral, emotional and spiritual growth of the students. It successfully highlighted how ancient teachings can guide young minds towards positive thinking, strong character and compassionate living in today’s world.
                                <br></br>
                                   
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ When young minds learn the wisdom of the Bhagavad Gita, they grow not only in knowledge, but in discipline, values and compassionate living. ”

                                <br />
                            </Typography>
                            </Box>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default GitaDharaClass6;